import { useTranslation } from 'react-i18next';
import { Icon, Settings } from 'pi-kiosk-shared/ui/Icon';
import { CUSTOMER_SHELL_ICON_BUTTON_CLASS } from './customerTopBarStyles.js';

export interface CustomerSettingsButtonProps {
  readonly open: boolean;
  readonly onOpen: () => void;
  readonly className?: string;
}

/**
 * Icon-only Settings gear — opens CustomerSettingsSheet (language · appearance · guest cookies).
 * HUX-01: omitted from root `/browse` first-row; open via MoreDrawer / `/more` / account secondary.
 */
export function CustomerSettingsButton({
  open,
  onOpen,
  className,
}: CustomerSettingsButtonProps): JSX.Element {
  const { t } = useTranslation('customer');
  const ariaLabel = t('chrome.settings.openAria', {
    defaultValue: t('chrome.settings.title'),
  });

  return (
    <button
      type="button"
      className={[CUSTOMER_SHELL_ICON_BUTTON_CLASS, className].filter(Boolean).join(' ')}
      aria-label={ariaLabel}
      aria-expanded={open}
      aria-haspopup="dialog"
      title={ariaLabel}
      data-testid="customer-shell-settings"
      onClick={onOpen}
    >
      <Icon icon={Settings} size={20} aria-hidden={true} />
    </button>
  );
}
